import React from "react";
import { IconX } from "../../icons/Icon";
import "../../assets/styles/btn-close.scss";

const BtnClose = ({ control }) => {
  return (
    <button
      type="button"
      className="smu-btn-close shadow"
      onClick={() => control()}
    >
      <IconX color="#E31C19" />
    </button>
  );
};

export default BtnClose;
